import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoginFormView } from '../model/login-form-view.model';

type LoginIconType = 'question' | 'login' | 'check-circle';

@Component({
  selector: 'py-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoginHeaderComponent {
  @Input() set view(data: LoginFormView) {
    this.setComponentData(data);
  }
  loginFormView = LoginFormView;
  iconType: LoginIconType;
  headerTextKey: string;
  contentTextKey: string;

  private setComponentData(viewType: LoginFormView): void {
    switch (viewType) {
      case LoginFormView.Login:
        this.setData('login', 'login.page_title', '');
        break;
      case LoginFormView.ForgotPassword:
        this.setData('question', 'password.forgotten.page_title', 'password.forgotten.description_text');
        break;
      case LoginFormView.ForgotUsername:
        this.setData('question', 'username.forgotten.page_title', 'username.forgotten.description_text');
        break;
      case LoginFormView.EmailSentForgotPassword:
        this.setData(
          'check-circle',
          'password.forgotten.confirmationPage_title',
          'password.forgotten.confirmationDescription_text'
        );
        break;
      case LoginFormView.EmailSentForgotUsername:
        this.setData(
          'check-circle',
          'username.forgotten.confirmationPage_title',
          'username.forgotten.confirmationDescription_text'
        );
        break;
    }
  }

  private setData(iconType: LoginIconType, headerTextKey: string, contentTextKey: string): void {
    this.iconType = iconType;
    this.headerTextKey = headerTextKey;
    this.contentTextKey = contentTextKey;
  }
}
